<template>
  <div class="info-detail" v-if="!loading">
    <info-items :items="items" :info="info">
      <div class="detail-item full-width">
        <div class="label">附件：</div>
        <upload-file-list class="attach-list" :canUpload="false" :canDelete="false" :attachList="attachList"></upload-file-list>
      </div>
    </info-items>
  </div>
</template>
<script>
import { ContractApis } from "@/apis";
import { AuditState } from "@/utils/enum";
import infoItems from "@/views/components/info-items.vue";
import UploadFileList from "@/views/components/upload-file-list";
export default {
  name: "info-detail",
  props: {
    type: String,
    id: String,
  },
  data() {
    return {
      loading: true,
      items: [],
      attachList: [],
      contractItems: [
        { label: "合同编号", prop: "contractNo" },
        { label: "合同名称", prop: "contractName" },
        { label: "客户名称", prop: "customerName" },
        { label: "合同金额", prop: "contractAmount" },
        { label: "签订日期", prop: "signDate" },
        { label: "合同开始日期", prop: "startDate" },
        { label: "合同结束日期", prop: "endDate" },
        { label: "客户签约人", prop: "linkName" },
        { label: "公司签约人", prop: "chargeName" },
        { label: "合同类型", prop: "contractTypeName" },
        { label: "备注", prop: "remark", class: "full-width" },
      ],
      receiptItems: [
        { label: "回款编号", prop: "collectionNo" },
        { label: "合同名称", prop: "contractName" },
        { label: "客户名称", prop: "customerName" },
        { label: "期数", prop: "collectionPeriod" },
        { label: "回款日期", prop: "collectionDate" },
        { label: "回款金额", prop: "collectionAmount" },
        { label: "回款方式", prop: "collectionModeName" },
        { label: "备注", prop: "remark", class: "full-width" },
      ],
      info: {},
    };
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    async getInfo() {
      let res;
      switch (this.type) {
        case "contract":
          this.items = this.contractItems;
          this.getContractInfo();
          res = await ContractApis.getContractAttachs(this.id);
          break;
        case "receipt":
          this.items = this.receiptItems;
          this.getReceiptInfo();
          res = await ContractApis.getRecordAttachList(this.id);
          break;

        default:
          break;
      }
      this.attachList = res;
    },
    async getContractInfo() {
      const res = await ContractApis.getContractById(this.id);
      res.auditState = AuditState[res.state];
      res.signDate = res.signDate && res.signDate.slice(0, 11);
      res.startDate = res.startDate && res.startDate.slice(0, 11);
      res.endDate = res.endDate && res.endDate.slice(0, 11);
      this.info = res;
      this.loading = false;
    },
    async getReceiptInfo() {
      const res = await ContractApis.getRecordById(this.id);
      res.auditState = AuditState[res.state];
      res.signDate = res.signDate && res.signDate.slice(0, 11);
      res.startDate = res.startDate && res.startDate.slice(0, 11);
      res.endDate = res.endDate && res.endDate.slice(0, 11);
      res.collectionDate = res.collectionDate && res.collectionDate.slice(0, 11);
      this.info = res;
      this.loading = false;
    },
  },
  components: { infoItems, UploadFileList },
};
</script>
<style scoped lang="scss">
.attach-list {
  flex: 1;
  overflow: hidden;
}
::v-deep {
  .detail-item {
    padding: 6px;
    .label {
      flex: 0 0 120px;
    }
  }
}
</style>
